import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const VariableContext = ({variable, pattr}) => { 
    let context = pattr.getVariableContext(variable);
    if (context === "") {
        return "";
    }
    return (<div className="variable-context">{context}</div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VariableContext);
